import { AuthUserService } from '../authsettings/services/authusers.service';
import { BaseService } from '../base/base.service';
import { AppService } from '../main/app.service';

export class IContact {
    id: string;
    accountId: string;
    accountName: string;
    firstName: string;
    middleName: string;
    lastName: string;
    name: string;
    emailAddress: string;
    userId: string;
    tags: string[];
}

export class ContactsService extends BaseService<IContact> {
    constructor(
        Restangular: Restangular.IService, 
        protected AppService: AppService,
        protected AuthUserService: AuthUserService) {
        "ngInject";
        super(Restangular, AppService, 'crm/contacts');
    }

    public deleteAccount(authUser, contact): ng.IPromise<any> {
        // console.log('ContactsService deleteAccount');
        return this.AuthUserService.delete(authUser.id).then(() => {
            contact.userId = "";
            return this.put(contact.id, contact).then((item) => {
                // console.log(contact);
                // console.log('Account removed');
                return item;
            });
        });
    }

    public createAccount(authUser, contact): ng.IPromise<any> {
        authUser.email = contact.emailAddress;
        authUser.userName = contact.emailAddress;
        authUser.roles = ['customer'];
        authUser.claims = {
            "displayName": contact.firstName + contact.lastName,
            "customerId": contact.accountId
        };
        return this.AuthUserService.post(authUser).then((response) => {
            contact.userId = response.id;
            return this.put(contact.id, contact).then((item) => {
                // console.log('Account created');
                return item;
            });
        });
    }

}


// WEBPACK FOOTER //
// ./src/app/services/contacts.service.ts